// Swiper autoplay keeps ticking while a carousel is off-screen. Each tick
// moves slides (and in loop mode re-orders them), forcing layout on the main
// thread, so a tap that lands during a tick responds late (hurts INP).
// Pass as `onSwiper` to run autoplay only while the carousel is visible.
export default function pauseAutoplayOffscreen(swiper) {
  if (!swiper?.el || typeof IntersectionObserver === "undefined") return;

  const observer = new IntersectionObserver(([entry]) => {
    if (swiper.destroyed || !swiper.autoplay) return;
    if (entry.isIntersecting) {
      if (!swiper.autoplay.running) swiper.autoplay.start();
    } else if (swiper.autoplay.running) {
      swiper.autoplay.stop();
    }
  });

  observer.observe(swiper.el);
  swiper.on("destroy", () => observer.disconnect());
}
